export var chatUnreadServiceUnreadMessagesCountSelector = function (state) {
    return state.content.unreadMessagesCount;
};
export var chatUnreadServiceHasUnreadMessagesSelector = function (state) {
    return state.content.unreadMessagesCount > 0;
};
export var chatUnreadServiceLoadingSelector = function (state) { return Boolean(state.loading); };
export var chatUnreadServiceInitializedSelector = function (state) { return Boolean(state.initialized); };
